'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleLabelStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  disabled: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  disabled: false
};
/** PROP RECEIVERS */

var labelSize = function labelSize(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var width = theme.reactackle.components.toggleButton.toggleBar.width,
      size = theme.reactackle.components.toggleButton.toggleThumb.size;
  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
};

var disabled = function disabled(_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? '\n      &,\n      & * {\n        cursor: default;\n      }\n    ' : '\n      &,\n      & * {\n        cursor: pointer;\n      }\n    ';
};
/** STYLES */


var ToggleLabelStyled = exports.ToggleLabelStyled = _styledComponents2.default.label.withConfig({
  displayName: 'ToggleLabelStyled'
})(['position:relative;display:block;user-select:none;', ';', ';&:hover,&:focus{outline:none;}'], labelSize, disabled);

ToggleLabelStyled.propTypes = propTypes;
ToggleLabelStyled.defaultProps = defaultProps;
ToggleLabelStyled.displayName = 'ToggleLabelStyled';